import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, inject } from "vue";
import Button from 'primevue/button';
import { ButtonProps } from "primevue/button";

export interface Props {
    severity?: ButtonProps["badgeSeverity"];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OpenNotebookButton',
  props: {
    severity: { default: "info" }
  },
  emits: [
  'open-file'
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showToast = inject<(options: object) => void>('show_toast');

const fileInput = ref(null);
const fileForm = ref(null);

const openFileSelection = () => {
   fileInput.value.click();
}

const onSelectFile = async (event) => {
  const file: File = event.target.files[0]; // ensure there's always one...

  if (!file.size ) {
    showToast({title: 'Error', detail: 'File looks empty. Check file.', severity: 'error', life: 10000});
    return;
  } else if (!/\.ipynb$/.test(file.name)) {
    showToast({title: 'File not ipynb.', detail: 'Beaker will try to load as json.', severity: 'warn', life: 4000});
  }

  const arrayBuffer = await file.arrayBuffer();
  const text = new TextDecoder().decode(arrayBuffer);

  try {
    const json = JSON.parse(text);
    emit('open-file', json, file.name);
  } catch(e) {
    console.error(e);
    showToast({
      title: 'Invalid File',
      detail: 'Unable to load. Please check file contains valid ipynb json data.',
      severity: 'error',
      life: 10000
    });
  }

  // Reset the file selection so that selecting a file later on
  // processes the onChange event properly
  fileForm.value.reset();
};



return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_unref(Button), {
      onClick: openFileSelection,
      icon: "pi pi-folder-open",
      size: "small",
      severity: props.severity,
      text: ""
    }, null, 8, ["severity"]), [
      [
        _directive_tooltip,
        {value: 'Open ipynb file', showDelay: 300},
        void 0,
        { bottom: true }
      ]
    ]),
    _createElementVNode("form", {
      id: "open-file-form",
      ref_key: "fileForm",
      ref: fileForm
    }, [
      _createElementVNode("input", {
        onChange: onSelectFile,
        ref_key: "fileInput",
        ref: fileInput,
        type: "file",
        style: {"display":"none"}
      }, null, 544)
    ], 512)
  ], 64))
}
}

})